import { render, staticRenderFns } from "./DevelopmentsPage.vue?vue&type=template&id=f4a485d6&scoped=true"
import script from "./DevelopmentsPage.vue?vue&type=script&lang=ts"
export * from "./DevelopmentsPage.vue?vue&type=script&lang=ts"
import style0 from "./DevelopmentsPage.vue?vue&type=style&index=0&id=f4a485d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a485d6",
  null
  
)

export default component.exports